import React from "react";
/** Services Import */
import Global from "../../Services/Common/Global";
import Commons from "../../Services/Common/Common";
import Dialog from "../../Services/Common/Dialog";
import IndexedDb from "../../Services/IndexedDb/IndexedDb";
/** Components Import */
import ST10060View from "../../Views/Stock/ST10060";
import Snackbar from "../../Components/Snackbar";
import { Landscape } from "@mui/icons-material";

function ST10060(props) {
  const [snackbars, setSnackbars] = React.useState({
    toggle: false,
    type: "",
    message: "",
  });
  const [inputs, setInputs] = React.useState({
    ItemCd: "",
    CustItemCd: "",
    ItemNm: "",
    ItemUnit: "",
    ItemStd: "",
    custList: [],
    itemList: [],
    itemListNm: [],
  });
  const [itemListCd, setItemListCd] = React.useState([]);
  const [checkInputs1, setCheckInputs1] = React.useState({
    value1: "",
    value2: "",
    value3: "",
    itemType: "",
  });
  const [whType, setWhType] = React.useState([]); //창고타입 콤보박스
  const [lanData, setLanData] = React.useState([]);
  const [rowData, setRowData] = React.useState([]);
  const [changedRowData, setChangedRowData] = React.useState([]);
  const [selectedRowData, setSelectedRowData] = React.useState([]);
  const [searchDate, setSearchDate] = React.useState(new Date());
  const [authGroupGridRowData1, setAuthGroupGridRowData1] = React.useState([]);
  const today = new Date();
  const monthAgo = new Date(today);
  const [startDate, setStartDate] = React.useState(
    monthAgo.setMonth(today.getMonth() - 3)
  );
  const today1 = new Date();
  const monthAgo1 = new Date(today1);
  const [startDate1, setStartDate1] = React.useState(
    monthAgo1.getDate(today1.getDate() - 1)
  );
  let selectedPoNo = "";
  const [endDate, setEndDate] = React.useState(new Date());
  React.useEffect(() => {
    window.addEventListener("error", (e) => {
      if (e.message === "ResizeObserver loop limit exceeded") {
        const resizeObserverErrDiv = document.getElementById(
          "webpack-dev-server-client- overlay-div"
        );
        const resizeObserverErr = document.getElementById(
          "webpack-dev-server-client-overlay"
        );
        if (resizeObserverErr) {
          resizeObserverErr.setAttribute("style", "display: none");
        }
        if (resizeObserverErrDiv) {
          resizeObserverErrDiv.setAttribute("style", "display: none");
        }
      }
    });

    const GetLanData = async () => {
      let getLanData = [];

      await IndexedDb.GetAllDb("LanguageList").then((result) => {
        if (result.length > 0) {
          getLanData = result.filter((f) => f.lanType !== "MENU");
        }
      });
      setLanData(getLanData);
    };
    GetLanData();
    SearchLogic();
    GetItemList();
    // Init();
  }, []);
  const GetItemList = async () => {
    let getLanData = [];
    let getComboData = [];
    try {
      await IndexedDb.GetAllDb("LanguageList").then((result) => {
        if (result.length > 0) {
          getLanData = result.filter((f) => f.lanType !== "MENU");
        }
      });
      setLanData(getLanData);

      await Commons.Axios(
        "get",
        Global.serverUrls.useUrl + Global.urls.logic.Common.GetItemList,
        { plantCd: "string", value: "string" }
      ).then((result) => {
        let data = result.data;
        for (let i = 0; i < data.length; i++) {
          getComboData.push({
            id: data[i].itemCd,
            label: data[i].ItemNm,
          });
        }
        setInputs({
          ...inputs,
          custList: [...getComboData],
        });
        // inputs.custList = getComboData;
      });
    } catch (e) {
      if (e.response.status === 401) {
        setSnackbars({
          toggle: true,
          type: "error",
          message: "로그인 정보가 만료되었습니다.",
        });
      } else {
        setSnackbars({
          toggle: true,
          type: "error",
          message: e.message,
        });
      }
    } finally {
    }
  };
  const SearchLogic = async () => {
    Dialog.ProgressBar(true);
    let getLanData = [];
    let getRowData = [];
    let getComboData = [];

    try {
      //창고코드 콤보박스
      await Commons.Axios(
        "get",
        Global.serverUrls.useUrl + Global.urls.logic.Common.GetWh,
        {
          whCd: "string",
        }
      ).then((result) => {
        let data = result.data;
        for (let i = 0; i < data.length; i++) {
          getComboData.push({
            value: data[i].value,
            name: data[i].name,
          });
        }
        inputs.comboWhCd = getComboData.filter(
          (e) => e.value.substring(0, 5) == "WH_MM"
        );
        inputs.comboMoveWhCd = getComboData.filter(
          (e) => e.value.substring(0, 5) == "WH_MM"
        );
        setWhType(getComboData);
      });
    } catch (e) {
      if (e.response.status === 401) {
        setSnackbars({
          toggle: true,
          type: "error",
          message: "로그인 정보가 만료되었습니다.",
        });
      } else {
        setSnackbars({
          toggle: true,
          type: "error",
          message: e.message,
        });
      }
    } finally {
      Dialog.ProgressBar(false);
    }
  };
  const Init = async () => {
    Dialog.ProgressBar(true);
    let getLanData = [];
    let getRowData = [];
    let getComboData = [];
    let getTranData = [];
    let totalStockQty = 0;
    try {
      await Commons.Axios(
        "get",
        Global.serverUrls.useUrl + Global.urls.logic.Stock.ST10060.GetTranList,
        {
          whs: inputs.whCd ? inputs.whCd : "string",
          items: inputs.item ? inputs.item : "string",
          startDate: new Date(startDate),
          endDate: endDate,
        }
      ).then((result) => {
        let data = result.data;
        if (data === "데이터가 없습니다.") {
          setSnackbars({
            toggle: true,
            type: "info",
            message: lanData.filter(
              (f) => f.lanId === "Snack_NullData" && f.lanType === "SNACK"
            )[0].lanName,
          });
          setRowData([]);
        } else if (data.type === "Error") {
          setSnackbars({
            toggle: true,
            type: "info",
            message: lanData.filter(
              (f) => f.lanId === "Snack_NullData" && f.lanType === "SNACK"
            )[0].lanName,
          });
        } else {
          setInputs({
            ...inputs,
            stockQty: data[0].stockQty ? data[0].stockQty : "0",
          });
          let stockTotal = 0; //수불타입에 따라 입고수량 , 출고수량 계산해서 담을 변수
          for (let i = 0; i < data.length; i++) {
            getTranData.push({
              tranDt: data[i].tranDt,
              custNm:
                data[i].transType === "501" //재고이동(추가)
                  ? data[i].whFromNm + " -> " + data[i].whNm
                  : data[i].transType === "502" //재고이동(차감)
                  ? data[i].whNm + " -> " + data[i].whFromNm
                  : data[i].custNm,
              inQty: data[i].inQty,
              outQty: data[i].outQty,
              stockQty:
                data[i].transType === "301" //생산
                  ? (stockTotal += data[i].inQty)
                  : data[i].transType === "302" //생산취소
                  ? (stockTotal -= data[i].outQty)
                  : data[i].transType === "401" //출하
                  ? (stockTotal -= data[i].outQty)
                  : data[i].transType === "402" //출하취소
                  ? (stockTotal += data[i].inQty)
                  : data[i].transType === "501" //재고이동(추가)
                  ? (stockTotal += data[i].inQty)
                  : data[i].transType === "502" //재고이동(차감)
                  ? (stockTotal -= data[i].outQty)
                  : "0",
              transTypeNm: data[i].transTypeNm,
            });
          }
          setRowData(getTranData);
        }
      });
    } catch (e) {
      if (e.response.status === 401) {
        setSnackbars({
          toggle: true,
          type: "error",
          message: "로그인 정보가 만료되었습니다.",
        });
      } else {
        setSnackbars({
          toggle: true,
          type: "error",
          message: e.message,
        });
      }
    } finally {
      Dialog.ProgressBar(false);
    }
  };

  const GetCommonItemList = async (_value) => {
    Dialog.ProgressBar(true);
    let userInfo = {};
    let deleteData = [];
    let getData = [];
    try {
      await IndexedDb.GetLoginInfo().then((result) => {
        userInfo = result;
      });
      await Commons.Axios(
        "get",
        Global.serverUrls.useUrl + Global.urls.logic.Common.GetItemList,
        {
          plantCd: "string",
          value: _value === "" ? "string" : _value,
        }
      ).then((result) => {
        let data = result.data;
        if (data === "데이터가 없습니다.") {
          setSnackbars({
            toggle: true,
            type: "error",
            message: data,
          });
          setAuthGroupGridRowData1([]);
        } else {
          for (let i = 0; i < data.length; i++) {
            getData.push({
              plantCd: data[i].plantCd,
              itemCd: data[i].itemCd,
              itemNm: data[i].itemNm,
              itemStd: data[i].itemStd,
              itemUnit: data[i].itemUnit,
              itemUnitNm: data[i].itemUnitNm,
              itemStdAmt: data[i].itemStdAmt,
              poItemCost: data[i].poItemCost,
              itemVatYn: data[i].itemVatYn,
              itemFormula: data[i].itemFormula,
            });
          }
          setAuthGroupGridRowData1(Commons.InsertNumber(getData));
        }
      });
    } catch (e) {
      if (e.response.status === 401) {
        setSnackbars({
          toggle: true,
          type: "error",
          message: "로그인 정보가 만료되었습니다.",
        });
      } else {
        setSnackbars({
          toggle: true,
          type: "error",
          message: e.message,
        });
      }
    } finally {
      Dialog.ProgressBar(false);
    }
  };

  return (
    <>
      <ST10060View
        lanData={lanData}
        rowData={rowData}
        setRowData={setRowData}
        changedRowData={changedRowData}
        setChangedRowData={setChangedRowData}
        setSelectedRowData={setSelectedRowData}
        searchDate={searchDate}
        setSearchDate={setSearchDate}
        Init={Init}
        setStartDate={setStartDate}
        startDate={startDate}
        setEndDate={setEndDate}
        endDate={endDate}
        inputs={inputs}
        setInputs={setInputs}
        whType={whType}
        GetCommonItemList={GetCommonItemList}
        checkInputs1={checkInputs1}
        setAuthGroupGridRowData1={setAuthGroupGridRowData1}
        authGroupGridRowData1={authGroupGridRowData1}
        itemListCd={itemListCd}
        setItemListCd={setItemListCd}
      />
      {snackbars.toggle && (
        <Snackbar snackbars={snackbars} setSnackbars={setSnackbars} />
      )}
    </>
  );
}

export default ST10060;
